import { render, staticRenderFns } from "./AccountBillingCreateComponent.vue?vue&type=template&id=16397e1c&scoped=true&"
import script from "./AccountBillingCreateComponent.vue?vue&type=script&lang=js&"
export * from "./AccountBillingCreateComponent.vue?vue&type=script&lang=js&"
import style0 from "./AccountBillingCreateComponent.vue?vue&type=style&index=0&id=16397e1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16397e1c",
  null
  
)

export default component.exports